{
  "status": {
    "draft": "Draft",
    "published": "Published",
    "archived": "Archived"
  },
  "submissionStatus": {
    "assigned": "Not started",
    "draft": "In progress",
    "submitted": "Handed in",
    "returned": "Returned for revision",
    "graded": "Graded"
  },
  "late": "Late",
  "list": {
    "title": "Homework",
    "description": "Assignments you issue to a class, then grade.",
    "searchPlaceholder": "Search homework…",
    "courseFilter": "Course",
    "classFilter": "Class",
    "statusFilter": "Status",
    "anyCourse": "Any course",
    "anyClass": "Any class",
    "anyStatus": "Any status",
    "due": "Due {{date}}",
    "noDue": "No due date",
    "maxScore": "Max score: {{score}}",
    "empty": {
      "title": "No homework yet",
      "text": "Create homework for a class, add the task content and publish it.",
      "filterText": "Nothing matches the current filters."
    },
    "actions": {
      "edit": "Edit",
      "view": "View",
      "submissions": "Submissions",
      "publish": "Publish",
      "unpublish": "Unpublish",
      "duplicate": "Duplicate",
      "archive": "Archive",
      "more": "More actions for {{title}}",
      "assign": "Assign to classes"
    },
    "published": "Homework published",
    "unpublished": "Homework moved back to draft",
    "duplicated": "Homework duplicated",
    "archived": "Homework archived",
    "archiveTitle": "Archive {{title}}?",
    "archiveDescription": "Pupils can no longer see this homework, and it stops accepting submissions. Existing submissions and grades stay.",
    "unassigned": "Not assigned to any class yet"
  },
  "create": {
    "button": "Create homework",
    "title": "Create homework",
    "description": "Pick the classes and the maximum score — the task content comes next.",
    "titleLabel": "Title",
    "titlePlaceholder": "e.g. Fractions — exercises 1–10",
    "noClasses": "No active classes — create a class first.",
    "maxScoreLabel": "Maximum score",
    "dueLabel": "Due date (optional)",
    "submit": "Create homework",
    "success": "Homework created",
    "failed": "Could not create the homework",
    "validation": "Choose at least one class and a maximum score",
    "noTaughtClasses": "You do not teach any active classes yet — ask an administrator to assign you to one.",
    "classesLabel": "Classes",
    "classesHint": "Parallel classes share the same homework — pick all that get this task. The due date below applies to each; you can adjust per class later.",
    "assignFailed": "Homework was created, but could not be assigned to: {{classes}}"
  },
  "editor": {
    "title": "Homework editor",
    "back": "Back to homework",
    "submissions": "Submissions",
    "homeworkTitle": "Title",
    "lesson": "Lesson",
    "noLesson": "No lesson",
    "maxScore": "Maximum score",
    "content": "Task",
    "save": "Save homework",
    "saved": "Homework saved",
    "saveFailed": "Could not save the homework",
    "unsaved": "Unsaved changes",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "duplicate": "Duplicate",
    "archive": "Archive",
    "blocksErrors": "Some blocks need fixing:",
    "leaveTitle": "Discard unsaved changes?",
    "leaveDescription": "Your latest edits have not been saved and will be lost.",
    "leaveConfirm": "Leave without saving",
    "readOnly": {
      "title": "You can read this homework, but not edit it",
      "text": "It belongs to another class. Only a school admin or a teacher of that class can change it or publish it."
    },
    "classes": "Assigned classes",
    "noAssignments": "Not assigned to any class yet — pupils cannot see it.",
    "assignmentDue": "due {{date}}",
    "assignmentNoDue": "no due date",
    "manageClasses": "Manage classes"
  },
  "review": {
    "title": "Submissions",
    "description": "Pupil submissions for {{title}}.",
    "back": "Back to the homework",
    "needsGradingOnly": "Needs grading only",
    "empty": "Nothing has been handed in yet.",
    "select": "Open {{name}}'s submission",
    "selected": "Reviewing",
    "none": "Choose a submission to review it.",
    "textAnswer": "Written answer",
    "noText": "No written answer.",
    "attachments": "Attachments",
    "noAttachments": "No attachments.",
    "scoreLabel": "Score (max {{max}})",
    "feedbackLabel": "Feedback",
    "grade": "Grade",
    "graded": "Submission graded",
    "return": "Return for revision",
    "returned": "Returned to the pupil",
    "returnNeedsFeedback": "Write the feedback the pupil should act on.",
    "failed": "Could not save",
    "score": "{{score}} / {{max}}",
    "notSubmitted": "Not handed in yet"
  },
  "pupilList": {
    "title": "Homework",
    "description": "Assignments from your classes.",
    "empty": {
      "title": "No homework right now",
      "text": "Homework your teachers assign to your classes appears here, with what you have handed in."
    },
    "due": "Due {{date}}",
    "noDue": "No due date",
    "open": "Open"
  },
  "detail": {
    "back": "Back to homework",
    "due": "Due {{date}}",
    "noDue": "No due date",
    "maxScore": "Max score: {{score}}",
    "task": "Task",
    "yourWork": "Your work",
    "textLabel": "Your answer",
    "textPlaceholder": "Write your answer here",
    "saveDraft": "Save draft",
    "savedDraft": "Draft saved",
    "attachments": "Attachments",
    "addFile": "Add file",
    "addImage": "Add image",
    "addVideo": "Add video",
    "addAudio": "Add audio",
    "addLink": "Add link",
    "linkLabel": "Link (Loom, YouTube, …)",
    "linkPlaceholder": "https://…",
    "linkAdd": "Add",
    "linkAdded": "Link added",
    "uploading": "Uploading… {{percent}}%",
    "uploadProgress": "Upload progress",
    "uploaded": "Attachment added",
    "removeAttachment": "Remove attachment",
    "removed": "Attachment removed",
    "submit": "Hand in",
    "resubmit": "Hand in again",
    "submitTitle": "Hand in your homework?",
    "submitDescription": "Your teacher will see everything you added here.",
    "submitted": "Homework handed in",
    "submitFailed": "Could not hand in the homework",
    "lockedGraded": "This homework has been graded — it is locked. Ask your teacher to return it if you need to change something.",
    "returnedNotice": "Your teacher asked for a revision",
    "feedback": "Teacher feedback",
    "score": "Score {{score}} / {{max}}",
    "lateNotice": "This was handed in after the due date."
  },
  "validation": {
    "titleRequired": "Title is required",
    "maxScoreRequired": "Set a maximum score"
  },
  "assign": {
    "title": "Assign to classes",
    "description": "The same homework can go to many classes — each class gets its own due date. Assigning published homework notifies its pupils immediately.",
    "classLabel": "Class",
    "classPlaceholder": "Choose a class",
    "noClasses": "No classes left to assign — you can only assign to classes you teach.",
    "dueAt": "Due date (optional)",
    "validation": "Choose a class first.",
    "success": "Homework assigned",
    "unassigned": "Assignment removed",
    "current": "Currently assigned",
    "none": "Not assigned to any class yet.",
    "due": "due {{date}}",
    "noDue": "no due date",
    "unassign": "Unassign {{name}}",
    "unassignTitle": "Unassign {{name}}?",
    "unassignDescription": "The class stops seeing this homework. Handed-in work and grades are kept.",
    "unassignConfirm": "Unassign",
    "submit": "Assign"
  },
  "lessonSection": {
    "title": "Homework for this lesson",
    "create": "Create homework",
    "empty": "No homework is linked to this lesson yet."
  }
}
